import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCheck,
  faChevronRight,
  faChevronDown,
  faExternalLinkAlt,
  faArrowDown,
  faTimes,
  faHome,
  faBars,
} from "@fortawesome/pro-solid-svg-icons";

import {
  faEye as farEye,
  faTimesCircle as farTimesCircle,
} from "@fortawesome/pro-regular-svg-icons";

import {
  faShoppingBasket as falShoppingBasket,
  faUserCircle as falUserCircle,
  faChevronRight as falChevronRight,
  faSignOut as falSignOut,
} from "@fortawesome/pro-light-svg-icons";

// pro solid
library.add(
  faCheck,
  faChevronRight,
  faChevronDown,
  faExternalLinkAlt,
  faArrowDown,
  faTimes,
  faHome,
  faBars,
);
// pro light
library.add(
  falShoppingBasket,
  falUserCircle,
  falChevronRight,
  falSignOut,
);
// pro regular
library.add(
  farTimesCircle,
  farEye,
);
